import React, { useState } from "react";
import BannerAnim from "rc-banner-anim";
import TweenOne, { TweenOneGroup } from "rc-tween-one";
import "rc-banner-anim/assets/index.css";
import "./index.less";

const { Element, Arrow, Thumb } = BannerAnim;
const BgElement = Element.BgElement;

/*
 across 左右滑动
 vertical 上下滑动
 acrossOverlay
 verticalOverlay
 gridBar 
*/

const Banner = (props) => {
  const { imgs, autoPlay, autoPlaySpeed, type } = props;

  const [thumbEnter, setThumbEnter] = useState(false);
  const [initShow, setInitShow] = useState(0);
  const [prevEnter, setPreEnter] = useState(false);
  const [nextEnter, setNextEnter] = useState(false);

  const onMouseEnter = () => setThumbEnter(true);

  const onMouseLeave = () => setThumbEnter(false);

  const prevEnterFn = () => {
    setPreEnter(true);
  };

  const prevLeave = () => {
    setPreEnter(false);
  };

  const nextEnterFn = () => {
    setNextEnter(true);
  };

  const nextLeave = () => {
    setNextEnter(false);
  };

  const getNextPrevNumber = () => {
    let nextInt = initShow + 1;
    let prevInt = initShow - 1;
    if (nextInt >= imgs.length) {
      nextInt = 0;
    }
    if (prevInt < 0) {
      prevInt = imgs.length - 1;
    }

    return [prevInt, nextInt];
  };

  const onChange = (type, int) => {
    if (type === "before") {
      setInitShow(int);
    }
  };

  const intArray = getNextPrevNumber();
  const thumbChildren = imgs.map((img, i) => (
    <span key={i}>
      <i style={{ backgroundImage: `url(${img})` }} />
    </span>
  ));

  return (
    <BannerAnim
      autoPlay={autoPlay}
      type={type}
      autoPlaySpeed={autoPlaySpeed}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onChange={onChange}
      prefixCls="custom-arrow-thumb"
    >
      {imgs.map((img, i) => (
        <Element prefixCls="banner-user-elem" key={i}>
          <BgElement
            key="bg"
            className="bg"
            style={{
              backgroundImage: `url(${img})`,
            }}
          />
        </Element>
      ))}
      <Arrow
        arrowType="prev"
        key="prev"
        prefixCls="user-arrow"
        component={TweenOne}
        onMouseEnter={prevEnterFn}
        onMouseLeave={prevLeave}
        animation={{ left: prevEnter ? 0 : -120 }}
      >
        <div className="arrow"></div>
        <TweenOneGroup
          enter={{ opacity: 0, type: "from" }}
          leave={{ opacity: 0 }}
          appear={false}
          className="img-wrapper"
          component="ul"
        >
          <li
            style={{ backgroundImage: `url(${imgs[intArray[0]]})` }}
            key={intArray[0]}
          />
        </TweenOneGroup>
      </Arrow>
      <Arrow
        arrowType="next"
        key="next"
        prefixCls="user-arrow"
        component={TweenOne}
        onMouseEnter={nextEnterFn}
        onMouseLeave={nextLeave}
        animation={{ right: nextEnter ? 0 : -120 }}
      >
        <div className="arrow"></div>
        <TweenOneGroup
          enter={{ opacity: 0, type: "from" }}
          leave={{ opacity: 0 }}
          appear={false}
          className="img-wrapper"
          component="ul"
        >
          <li
            style={{ backgroundImage: `url(${imgs[intArray[1]]})` }}
            key={intArray[1]}
          />
        </TweenOneGroup>
      </Arrow>
      <Thumb
        prefixCls="user-thumb"
        key="thumb"
        component={TweenOne}
        animation={{ bottom: thumbEnter ? 0 : -70 }}
      >
        {thumbChildren}
      </Thumb>
    </BannerAnim>
  );
};

const SimpleBanner = (props) => {
  const { imgs, autoPlay, autoPlaySpeed, type } = props;
  return (
    <BannerAnim
      autoPlay={autoPlay}
      type={type}
      autoPlaySpeed={autoPlaySpeed}
      prefixCls="custom-arrow-thumb"
    >
      {imgs.map((img, i) => (
        <Element prefixCls="banner-user-elem" key={i}>
          <BgElement
            key="bg"
            className="bg"
            style={{
              background: `url(${img})`,
              backgroundSize: "cover",
            }}
          />
        </Element>
      ))}
    </BannerAnim>
  );
};

const CommonBanner = (props) => {
  return props.preview ? <Banner {...props} /> : <SimpleBanner {...props} />;
};

CommonBanner.defaultProps = {
  preview: false,
  imgs: [],
  autoPlay: true,
  autoPlaySpeed: 3000,
  type: ["acrossOverlay"],
};

export default CommonBanner;
